import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Context } from "../index";
import ProductItem from "./ProductItem";
import { Truck, Gear, Headset, Wallet2, ShieldCheck, Check2All } from 'react-bootstrap-icons';
import { XCircle } from 'lucide-react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

const ProductList = observer(() => {
    const { product } = useContext(Context)
    const handleClose = () => console.log(0);
    const navigate = useNavigate();

  if (!product.products || product.products.length === 0) {
    return (
      <Container className="mb-4 px-0">
        <div className="d-flex flex-column justify-content-center align-items-center text-center w-100 py-5">
          <XCircle size={80} className="text-danger mb-3" />
          <h4>Товары не найдены </h4>
          <h5> Попробуйте изменить парамертры поиска </h5>
          <div className="d-flex gap-3 flex-wrap justify-content-center pb-5" >
            <Button
                variant="outline-success"
                className="d-flex align-items-center rounded-4 custom-green-outline"
                onClick={() => navigate('/catalog')}
              >
                <Check2All className="me-2" />
                Вернуться в каталог
            </Button>
            </div>
        </div>
      </Container>
    );
  }
   
    return (
        <Container className="mb-4 products d-flex justify-content-start flex-wrap align-items-stretch px-0">
        {product.products.map((product, index) => (
           <React.Fragment key={product.id}>
           <ProductItem 
               productItem={product} 
               handleClose={handleClose} 
               index={index + 1} // Передаем индекс продукта
           />
           {index === 9 && (
               <div className="d-none d-xl-flex align-items-center justify-content-between align-self-stretch advline my-5">
                   <div className="d-flex align-items-center">
                       <div className="adv_item d-flex align-items-center justify-content-center me-3"><Truck className="text-light"/></div>
                       <div className="adv_text fw-bold me-3">Доставка<br/><span className="fw-normal text-secondary">Доставка по всей территории РФ</span></div>
                   </div>
                   <div className="d-flex align-items-center">
                       <div className="adv_item d-flex align-items-center justify-content-center me-3"><Gear className="text-light"/></div>
                       <div className="adv_text fw-bold me-3">Монтаж<br/><span className="fw-normal text-secondary">Установка оборудования любой сложности</span></div>
                   </div>
                   <div className="d-flex align-items-center">
                       <div className="adv_item d-flex align-items-center justify-content-center me-3"><Headset className="text-light"/></div>
                       <div className="adv_text fw-bold me-3">Удобный сервис<br/><span className="fw-normal text-secondary">Наши специалисты всегда с вами на связи</span></div>
                   </div>
                   <div className="d-flex align-items-center">
                       <div className="adv_item d-flex align-items-center justify-content-center me-3"><ShieldCheck className="text-light"/></div>
                       <div className="adv_text fw-bold me-3">Гарантия<br/><span className="fw-normal text-secondary">До 5 лет, бесплатный ремонт по гарантии</span></div>
                   </div>
                   <div className="d-flex align-items-center">
                       <div className="adv_item d-flex align-items-center justify-content-center me-3"><Wallet2 className="text-light"/></div>
                       <div className="adv_text fw-bold me-3">Оплата<br/><span className="fw-normal text-secondary">Оплата как за наличный, так и безналичный расчет</span></div>
                   </div>
               </div>
           )}
       </React.Fragment>
   ))}
</Container>
);
});

export default ProductList;